import { useEffect, useState } from "react";

interface EmptyStateProps {
  isLoading: boolean;
  isStats?: boolean;
  isDarkMode: boolean;
  setWalletAddress: (address: string) => void;
}

const DISPLAY_WALLETS: { address: string; name: string }[] = [
  {
    address: "0xe6e077563791a861936E4f31342a7394d748cD67",
    name: "#1 pet",
  },
  {
    address: "0xc2Cd6C982d5Ba787c70d47c5BD2FEdEE21160CC2",
    name: "Dev pet",
  },
  {
    address: "0x5b95A971B4583A5f011E9DA082acdD679b870D06",
    name: "FP dragon",
  },
];

export function EmptySelectState({
  setWalletAddress,
  isLoading,
  isStats = false,
  isDarkMode,
}: EmptyStateProps) {
  const [loadingText, setLoadingText] = useState(".");
  const [penguinSrc, setPenguinSrc] = useState("/imgs/fp_penguin_idle.png");

  const handleSelectAddress = (address: string) => {
    setWalletAddress(address);
  };

  useEffect(() => {
    if (isLoading) {
      const ellipsisInterval = setInterval(() => {
        setLoadingText((prev) => {
          return prev === "" ? "." : prev === "." ? ".." : prev === ".." ? "..." : "";
        });
      }, 500);

      const penguinInterval = setInterval(() => {
        setPenguinSrc((prev) =>
          prev === "/imgs/fp_penguin_idle.png"
            ? "/imgs/fp_penguin.png"
            : "/imgs/fp_penguin_idle.png",
        );
      }, 500);

      return () => {
        clearInterval(ellipsisInterval);
        clearInterval(penguinInterval);
      };
    }
  }, [isLoading]);

  return (
    <div
      className={`mt-2 flex flex-col items-center justify-center rounded-lg border-2 ${isDarkMode ? "border-darkgreen bg-darkblue text-white [box-shadow:inset_0_-2px_#37b764]" : "border-brown bg-white text-brown [box-shadow:inset_0_-2px_#342e2e]"} w-[22.5rem] p-3`}
    >
      <div className="flex w-full flex-col items-center justify-center">
        <a href={`https://frenpet.xyz/`} target="_blank" rel="noreferrer">
          <img src={penguinSrc} alt="" className="h-32 w-36" />
        </a>
        <h1 className="font-bold">Fren Pet Analytica</h1>
        <div className="ml-1 flex flex-row">
          <img
            src={isDarkMode ? "/imgs/darkpaw.svg" : "/imgs/paw.svg"}
            alt=""
            className="mr-[0.7rem] mt-2 h-4 w-4"
          />
          {isLoading ? (
            <h2 className="mt-2 text-sm font-semibold">
              {isStats ? "Loading stats" : "Loading your Fren Pet data"}
              <div className="inline-block min-w-5 pr-1 text-left">{loadingText}</div>
            </h2>
          ) : (
            <h2 className="mt-2 text-sm font-semibold">Your Fren Pet data</h2>
          )}
          <img
            src={isDarkMode ? "/imgs/darkpaw.svg" : "/imgs/paw.svg"}
            alt=""
            className="ml-1 mr-[0.3rem] mt-2 h-4 w-4"
          />
        </div>
      </div>
      {isLoading ? (
        <p className="mt-3 flex flex-row text-center text-sm"></p>
      ) : (
        <div className="flex h-full w-[22.5rem] flex-col">
          <p className="mt-3 text-center text-sm">
            To view pets, stats, and balances, enter your wallet address
          </p>
          <div
            className={`mt-2 w-full border-b-2 ${isDarkMode ? "border-darkgreen" : "border-brown"}`}
          ></div>
          <p
            className={`mt-4 text-center text-sm font-semibold ${
              isDarkMode ? "text-grey" : "text-darkbrown"
            }`}
          >
            Explore without a pet
          </p>
          <div className="mb-2 mt-2 w-full space-y-3">
            {DISPLAY_WALLETS.map(({ address, name }) => (
              <div
                key={address}
                className={`mx-auto flex w-fit items-center justify-center rounded-md border px-3 py-2 ${
                  isDarkMode
                    ? "border-darkgreen [box-shadow:inset_0_-2px_#37b764] hover:bg-darkblack hover:text-darkgreen"
                    : "hover:text-darkbrown border-brown [box-shadow:inset_0_-2px_#342e2e] hover:bg-green"
                } cursor-pointer`}
                onClick={() => handleSelectAddress(address)}
              >
                <span className="text-sm">{name}</span>
              </div>
            ))}
          </div>
          <div
            className={`mt-2 border-b-2 ${isDarkMode ? "border-darkgreen" : "border-brown"}`}
          ></div>
          <p
            className={`mt-4 text-center text-sm font-semibold ${
              isDarkMode ? "text-grey" : "text-darkbrown"
            }`}
          >
            Mint your own pet
          </p>
          <div
            className={`mx-auto mb-2 mt-2 flex w-fit items-center justify-center rounded-md border px-3 py-2 ${
              isDarkMode
                ? "border-darkgreen [box-shadow:inset_0_-2px_#37b764] hover:bg-darkblack hover:text-darkgreen"
                : "border-brown [box-shadow:inset_0_-2px_#342e2e] hover:bg-green hover:text-white"
            } cursor-pointer`}
            onClick={() => window.open("https://pet.game", "_blank")}
          >
            <span className="text-sm">
              <img
                src={isDarkMode ? "/imgs/passBadgeDark.png" : "/imgs/passBadge.png"}
                alt=""
                className="z-10 mr-[.1rem] mt-[0.05rem] h-5 w-5"
              />
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
